/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeedSettingsPreviewRequest
 */
export interface FeedSettingsPreviewRequest {
    /**
     * 
     * @type {object}
     * @memberof FeedSettingsPreviewRequest
     */
    criteria: object;
}

/**
 * Check if a given object implements the FeedSettingsPreviewRequest interface.
 */
export function instanceOfFeedSettingsPreviewRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "criteria" in value;

    return isInstance;
}

export function FeedSettingsPreviewRequestFromJSON(json: any): FeedSettingsPreviewRequest {
    return FeedSettingsPreviewRequestFromJSONTyped(json, false);
}

export function FeedSettingsPreviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedSettingsPreviewRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criteria': json['criteria'],
    };
}

export function FeedSettingsPreviewRequestToJSON(value?: FeedSettingsPreviewRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criteria': value.criteria,
    };
}

